import { validateBudgetRange } from '@/components/ModifyBudget';
import type { ChannelBound } from './channelBounds';
import type { ChannelInput } from '@/dashboards/shared/optimisation/optimisationSession';

export const resolveChannelSubmit = ({
    value,
    bounds,
}: {
    value: ChannelInput;
    bounds: ChannelBound | undefined;
}): { value: ChannelInput; outOfBounds: boolean } => {
    if (!value.locked || !bounds) return { value, outOfBounds: false };
    const max = Math.max(bounds.min, bounds.max);
    const { isValid } = validateBudgetRange(value.investment, bounds.min, max);
    if (isValid) return { value, outOfBounds: false };
    return { value: { ...value, investment: bounds.recommended }, outOfBounds: true };
};
